import { useTranslation } from 'react-i18next';

import { type GameStates } from '@pkg/hooks/fantasyWishlists';

interface StatusContent {
    adminStatusCopy?: string;
    gameCardCTA?: string;
}

type StatusContentOptions = { [Key in GameStates]?: StatusContent };

export function useGameStatusContent(gameStatus: GameStates) {
    const { t: translate } = useTranslation(['fantasy_wishlist']);
    const statusOptions: StatusContentOptions = {
        upcoming: {
            adminStatusCopy: 'opening soon',
            gameCardCTA: translate('cta_opening_soon'),
        },
        open: {
            gameCardCTA: translate('cta_play_now'),
            adminStatusCopy: 'started',
        },
        playing: {
            adminStatusCopy: 'started',
            gameCardCTA: translate('cta_manage'),
        },
        closed: {
            adminStatusCopy: 'closed',
            gameCardCTA: translate('cta_view'),
        },
        ended: {
            adminStatusCopy: 'ended',
            gameCardCTA: translate('cta_view'),
        },
    };

    const adminStatusCopy = statusOptions[gameStatus]?.adminStatusCopy;
    const gameCardCTA = statusOptions[gameStatus]?.gameCardCTA;

    return {
        adminStatusCopy,
        gameCardCTA,
    };
}
